import { FieldsEnum, FormsEnum } from 'app/shared/enums';
import { setQuestionVisibility } from 'app/services/businessFunctionHelpers';
import { isMan } from 'app/services/pesel.service';

export function setFamilyNameVisibility(
  fieldKey: FieldsEnum,
  formName: FormsEnum,
  pesel: string,
  isPeselValid: boolean
) {
  setQuestionVisibility({
    key: fieldKey,
    visible: isPeselValid && !isMan(pesel),
    formName,
  });
}
